import { CROP_IMAGE_MODAL_MODULE_ID } from 'root/src/shared/descriptions/modules/moduleIds'

export default {
	[CROP_IMAGE_MODAL_MODULE_ID]: {
		moduleType: 'modal',
		modalTitle: 'Edit Image',
	},
}
